import TeachersGrid from './TeachersGrid';

export default TeachersGrid;